import {createSelector} from 'reselect';

import marketConfigService from '../../services/marketConfigService';
import {
    makeSelectConsumerProductsMergedInfo,
    makeSelectIotDeviceMergedWithConsumerProduct,
    selectConsumerProducts,
    selectConsumerProductsInfo,
} from './consumer';
import {selectDeviceConnectionStatus, selectIotDeviceData} from './iotDevice';

const makeSelectConsumerProductByIotProduct = () =>
    createSelector(
        selectConsumerProducts,
        makeSelectIotDeviceMergedWithConsumerProduct(),
        (consumerProducts, iotProduct) => {
            return consumerProducts?.find((product) => product.deviceSerialNumber === iotProduct.deviceSerialNumber);
        }
    );

const makeSelectConsumerProductMaterialByType = (isHolder) =>
    createSelector(selectConsumerProductsInfo, selectIotDeviceData, (productsInfo, iotProduct) => {
        if (!iotProduct || !productsInfo) return null;

        const deviceSerialNumber = isHolder ? iotProduct.holder?.deviceSerialNumber : iotProduct.deviceSerialNumber;

        if (!deviceSerialNumber) return null;

        const productInfo = productsInfo.find((productInfo) => productInfo.deviceSerialNumber === deviceSerialNumber);

        return productInfo?.material;
    });

const makeSelectCommonProducts = () =>
    createSelector(
        makeSelectConsumerProductsMergedInfo(),
        makeSelectConsumerProductByIotProduct(),
        selectDeviceConnectionStatus,
        makeSelectIotDeviceMergedWithConsumerProduct(),
        (consumerProducts, consumerProductByIotProduct, deviceConnectionStatus, iotProduct) => {
            const isDeviceListEnabled = marketConfigService.isDeviceListEnabled();

            if (consumerProducts && iotProduct.device) {
                const {device, holder, device_management_features_config, device_global_features_config} = iotProduct;
                const {name, type, deviceSerialNumber} = device;
                const status = consumerProductByIotProduct?.status;
                const isDeviceSupported = marketConfigService.isDeviceSupported(type);
                const restConsumerProducts = consumerProducts.filter(
                    (product) => product.deviceSerialNumber !== deviceSerialNumber
                );

                const iotDeviceMapped = {
                    ...device,
                    deviceConnectionStatus,
                    device_management_features_config,
                    device_global_features_config,
                    deviceSerialNumber,
                    isDeviceSupported,
                    isIotProduct: true,
                    productName: name,
                    status,
                };

                if (holder) {
                    iotDeviceMapped.holder = {...holder};
                }

                restConsumerProducts.unshift(iotDeviceMapped);

                if (isDeviceListEnabled) {
                    return restConsumerProducts;
                } else {
                    return restConsumerProducts.filter((product) => product.isIotProduct);
                }
            } else {
                return isDeviceListEnabled ? consumerProducts : [];
            }
        }
    );

export {makeSelectCommonProducts, makeSelectConsumerProductMaterialByType};
